import { useCallback, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import get from 'lodash/get'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'

import ContinueBooking from '../widgets/ContinueBooking'
import { interpolate, useTranslations } from 'common/language'
import ModalTrigger from 'common/modals/ModalTrigger'
import { Button, BynderPicture, QuoteCard, Typography } from 'common/widgets'
import useSessionStorage from 'hooks/useSessionStorage'
import widgetClassNames from '../widgets/styles.module.scss'
import classNames from './styles.module.scss'


QuoteCardWrapper.propTypes = {
  data: PropTypes.shape({
    school_name: PropTypes.string,
    image: PropTypes.string,
    uuid: PropTypes.string,
    shopping_cart: PropTypes.object,
    school: PropTypes.object,
    exchange_rate: PropTypes.object,
  }).isRequired,
  ind: PropTypes.number,
  isOpen: PropTypes.bool,
  setOpen: PropTypes.func,
  quote: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  hasBooker: PropTypes.bool,
  isGroupOperation: PropTypes.bool,
  option: PropTypes.string,
}

export default function QuoteCardWrapper({
  ind = undefined,
  data,
  option = '',
  quote = '',
  isOpen = false,
  setOpen = noop,
  firstName = '',
  lastName = '',
  hasBooker = false,
  isGroupOperation = false,
}) {
  const [, setBookingData] = useSessionStorage('bookingData')
  const { gettext, languageCode } = useTranslations()
  const cardImage = useMemo(() => {
    const firstImage = get(data, 'school.static_content.media_images[0]', {})
    return {
      bynder: firstImage.bynder,
      data: {
        alttext: firstImage.data?.[`alttext_${languageCode}`],
        name: firstImage.data?.[`name_${languageCode}`],
      },
    }
  }, [data.school])
  const handleOpen = useCallback(() => setOpen(isOpen ? null : ind), [isOpen, setOpen])
  const cartData = useMemo(() => ({ school_name: data.school.name, exchange_rate: data.exchange_rate, ...data.shopping_cart }), [data])
  return (
    <div className={cx(classNames.quoteCardWrapper, isOpen && classNames.open)}>
      <div onClick={handleOpen}>
        {(ind || data.school_name) && (
          <div className={classNames.quoteCardTitle}>
            <div>
              {ind && (
                <Typography
                  variant="h4"
                  transform="uppercase"
                  className={classNames.optionTitle}
                >
                  {interpolate(gettext('Option %s'), [ind])}
                </Typography>
              )}
              {get(data, 'school.name') && (
                <Typography
                  color="black"
                  variant="quote-card-title"
                  tag="div"
                  className={classNames.schoolMobileName}
                >
                  {data.school.name}
                </Typography>
              )}
            </div>
            <FontAwesomeIcon icon={isOpen ? 'caret-up' : 'caret-down'} />
          </div>
        )}
        {cardImage.bynder && (
          <div className={classNames.quoteHero}>
            <BynderPicture
              image={cardImage}
              priority
              mobileImage={{
                maxWidth: 720,
                maxHeight: 360,
                sizes: '100vw',
              }}
              desktopImage={{
                maxWidth: 600,
                maxHeight: 200,
                sizes: '33vw',
              }}
            />
          </div>
        )}
      </div>
      <div className={classNames.quoteCard}>
        <QuoteCard option={cartData} isSchoolName={Boolean(cartData.school_name)}>
          {quote && option && (
            <div className={classNames.quoteCardFooter}>
              <Button
                to={{
                  pathname: '/quote/list/[id]/detail/[option]',
                  query: {
                    id: quote,
                    option,
                  },
                }}
                prefetch
                className={classNames.quoteCardButton}
                passHref
              >
                {gettext('View Option')}
              </Button>
              <ModalTrigger
                title={gettext('Continue booking')}
                component={ContinueBooking}
                setBookingData={setBookingData}
                cart={data}
                modalClassName={widgetClassNames.modalWrapper}
                state={{
                  firstName,
                  lastName,
                  hasBooker,
                  isGroupOperation,
                  quote,
                  option,
                }}
              >
                <Button className={classNames.quoteCardButton}>
                  {gettext('Book Option')}
                </Button>
              </ModalTrigger>
            </div>
          )}
        </QuoteCard>
      </div>
    </div>
  )
}
